import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { NameValue } from "projects/sepidz-web-framework/src/lib/models/name-value";
import { LocalSettingFormComponent } from "../local-setting-form/local-setting-form.component";
import { LocalStoreManager } from "projects/sepidz-web-framework/src/lib/services";
import { ClearableCache } from "projects/sepidz-web-framework/src/lib/models/clearablecache.model";

@Component({
  selector: "ngx-local-setting-list",
  templateUrl: "./local-setting-list.component.html",
  styleUrls: ["./local-setting-list.component.scss"],
})
export class LocalSettingListComponent extends BaseListComponent {
  filterInfo: NameValue[] = [];
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  constructor(private storage: LocalStoreManager) {
    super();
    this.inputEditorform = LocalSettingFormComponent;
  }
  ngOnInit() {
    this.apiName = "LocalSetting";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.LocalSetting.LocalSettings");
    const computerName: string = this.storage.getData(ClearableCache.ComputerName);
    this.filterInfo.push({ Name: "ComputerName", Value: computerName, Operator: "eq" });
  }
}
